import React, { useMemo } from 'react';

import { UseGetPivotTableProvider } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/PivotBoard.provider';
import { groupedOptionsBaseList } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/PivotBoard.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/components/Filters/PivotFilters.module.scss';
import { getSecondaryGroupedOptionList } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/components/Filters/PivotFilters.utils';
import { Select } from 'components/DesignSystem/Select';

interface Props {
    ui: UseGetPivotTableProvider['ui'];
    collapseOnSecondaryGroupChange: () => void;
}

export const PivotFilters = ({ ui, collapseOnSecondaryGroupChange }: Props) => {
    const secondaryGroupOptions = useMemo(() => {
        const options = getSecondaryGroupedOptionList(ui.state.primaryGroupSelected, groupedOptionsBaseList);
        return options;
    }, [ui.state.primaryGroupSelected]);

    return (
        <div className={classes.PivotFiltersContainer}>
            <Select<ISelectOption<string>>
                value={ui.state.primaryGroupSelected}
                onChange={(value: ISelectOption<string>) => {
                    ui.setters.setPrimaryGroupSelected(value);
                    // set ui.setters.setSecondaryGroupSelected to NULL to prevent situations where both selects has the same value
                    ui.setters.setSecondaryGroupSelected(null);
                }}
                options={groupedOptionsBaseList}
                label={'Primary Group by'}
            />
            <Select<ISelectOption<string>>
                value={ui.state.secondaryGroupSelected}
                onChange={(value: ISelectOption<string> | null) => {
                    ui.setters.setSecondaryGroupSelected(value);
                    collapseOnSecondaryGroupChange();
                }}
                options={secondaryGroupOptions}
                label={'Secondary Group by'}
                isClearable={true}
            />
        </div>
    );
};
